import { Cents, formatMoney, toMoney } from '@betterment/js-runtime';

export function toFormattedMoney(value?: Cents) {
  if (value === undefined) {
    return 'unavailable';
  }

  return formatMoney(toMoney(value));
}
